import { Platform } from 'react-native';
import styled from 'styled-components/native';

export const Container = styled.View`
  padding: 15px 10px;
  flex: ${Platform.OS !== 'web' ? 1 : 'none'};
`;
